import ReactDOM from "react-dom";

import App from "./App";
import { AppStateProviders } from "./context";
import ThemeProviders from "./styles";

ReactDOM.render(
  <AppStateProviders>
    <ThemeProviders>
      <App />
    </ThemeProviders>
  </AppStateProviders>,
  document.getElementById("root")
);
